export default __webpack_public_path__ + "static/media/14.bbe9f2b5.jpg";